import {
  ApplicationRef,
  Component,
  ElementRef,
  inject,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { DrupalRichTextLinkDirective } from '@nx-massaud/utils';
import {
  ErrorsPipe,
  IsJsonApiError,
  JsonApiErrorMessage,
} from '@nx-massaud/loading/pipes';
import { LetDirective } from '@ngrx/component';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'nx-massaud-m-loading',
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    DrupalRichTextLinkDirective,
    ErrorsPipe,
    IsJsonApiError,
    JsonApiErrorMessage,
    LetDirective,
    MatIconModule,
  ],
  template: `
    <ng-container *ngIf="!errorMessage">
      <mat-icon [svgIcon]="'downloading'" class="loading"></mat-icon>
    </ng-container>
    <ng-container *ngIf="errorMessage">
      <mat-icon [svgIcon]="'error'"></mat-icon>
      <ng-container *transloco="let t">
        <p [innerHTML]="t(errorMessage)" i2lDrupalRichTextLink></p>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="errors">
      <span class="more-details" (click)="onShowErrors()"
        >plus de détail...</span
      >
      <ng-container *ngIf="showErrors">
        <ng-template ngFor [ngForOf]="errors" let-error>
          <div class="error-group">
            <ng-container *ngrxLet="error | isJsonApiError as isJsonApiError">
              <div class="error-header-group">
                <small [innerHTML]="error | errors : 'status'"></small>
                <a [href]="error | errors : 'url'" target="_blank"
                  >URL Request</a
                >
              </div>
              <ng-container *ngIf="isJsonApiError">
                <p [innerHTML]="error | jsonApiErrorMessage"></p>
              </ng-container>
            </ng-container>
          </div>
        </ng-template>
      </ng-container>
    </ng-container>
  `,
  styleUrls: ['./m-loading.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ErrorsPipe],
})
export class MLoadingComponent {
  el: ElementRef<HTMLElement> = inject(ElementRef<HTMLElement>);
  applicationRef: ApplicationRef = inject(ApplicationRef);

  @Input()
  errorMessage: string | undefined;

  @Input()
  errors: Error[] | undefined;

  showErrors = false;

  @Input()
  set classes(classes: string[] | undefined) {
    if (classes) {
      this.el.nativeElement.classList.add(...classes);
    }
  }

  onShowErrors() {
    this.showErrors = !this.showErrors;
    this.applicationRef.tick();
    console.log('this.showErrors', this.showErrors);
  }
}
